import "./firebase";
// import { Settings } from "react-native-fbsdk-next";
import "react-native-reanimated";
import { Platform } from "react-native";
import useFontLoader from "./app/hooks/useFontLoader";
import AppNav from "./app/screens/navigations/AppNav";
import { AuthProvider } from "./app/context/AppContext";
import * as SplashScreen from "expo-splash-screen";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";

const queryClient = new QueryClient();
// import useFonts from './hooks/useFontsHook';
SplashScreen.preventAutoHideAsync();

// if (Platform.OS === "web" && typeof document !== "undefined") {
//   const style = document.createElement("style");
//   style.textContent = `
//     body { overflow: auto !important; }
//     html { height: 100%; }

//     /* Target React Navigation web containers */
//     #root > div,
//     #root > div > div,
//     #root > div > div > div {
//       overflow: visible !important;
//       height: auto !important;
//     }

//     /* Target all deeply nested RN web divs */
//     [data-focusable="true"],
//     .r-overflow-1udh08x {
//       overflow: visible !important;
//     }
//   `;
//   document.head.appendChild(style);
// }

// if (Platform.OS === "web" && typeof document !== "undefined") {
//   const style = document.createElement("style");
//   style.textContent = `
//     html, body, #root {
//       height: 100%;
//       overflow: hidden;
//     }

//     /* Let the navigator itself scroll, not the body */
//     #root > div {
//       height: 100%;
//       overflow: hidden;
//     }
//   `;
//   document.head.appendChild(style);
// }

// if (Platform.OS === "web" && typeof document !== "undefined") {
//   const style = document.createElement("style");
//   style.textContent = `
//     html, body, #root {
//       height: 100%;
//       margin: 0;
//       padding: 0;
//       overflow: hidden;
//     }
//   `;
//   document.head.appendChild(style);
// }

// if (Platform.OS === "web" && typeof document !== "undefined") {
//   const style = document.createElement("style");
//   style.textContent = `
//     html, body {
//       margin: 0;
//       padding: 0;
//       height: 100%;
//     }
//   `;
//   document.head.appendChild(style);
// }

// if (Platform.OS === "web" && typeof document !== "undefined") {
//   const style = document.createElement("style");

//   style.textContent = `
//     html,
//     body,
//     #root {
//       height: 100%;
//       margin: 0;
//       padding: 0;
//       background: white;
//     }

//     body {
//       overscroll-behavior-y: none;
//     }
//   `;

//   document.head.appendChild(style);
// }

if (Platform.OS === "web" && typeof document !== "undefined") {
  const style = document.createElement("style");

  style.textContent = `
    html, body, #root {
      height: 100%;
      margin: 0;
      padding: 0;
      overflow: auto;   /* MUST BE auto */
    }
  `;

  document.head.appendChild(style);
}

export default function App() {
  const [appIsReady, setAppIsReady] = useState(false);

  // Settings.initializeSDbK();
  // Settings.setAdvertiserTrackingEnabled(true);

  const fontLoaded = useFontLoader({
    "Sen-Regular": require("./assets/fonts/Sen-Regular.ttf"),
    "Sen-Bold": require("./assets/fonts/Sen-Bold.ttf"),
    "Sen-Medium": require("./assets/fonts/Sen-Medium.ttf"),
  });

  // This effect will run when fontLoaded changes
  // useEffect(() => {
  //   if (fontLoaded) {
  //     setAppIsReady(true);
  //   }
  // }, [fontLoaded]);

  const onLayoutRootView = useCallback(async () => {
    if (appIsReady) {
      await SplashScreen.hideAsync();
    }
  }, [appIsReady]);

  useEffect(() => {
    async function prepare() {
      try {
        await SplashScreen.preventAutoHideAsync();
        // Here you would add any other async loading tasks
        // await someAsyncDataLoad();
      } catch (e) {
        //console.warn(e);
      } finally {
        if (fontLoaded) {
          // This ensures the splash screen is hidden ONLY after fonts are loaded
          // and the initial app render is about to occur.
          //console.log('Font has loaded')
          await SplashScreen.hideAsync();
          //console.log('splashScreen closing')
          setAppIsReady(true);
        }
      }
    }
    prepare();
  }, [fontLoaded]); // The effect will re-run when fonts are loaded

  if (!appIsReady) {
    return null; // Keep the splash screen visible
  }

  // if (!fontLoaded) {
  //   // return <Text>Loading font...</Text>;
  //   return null
  // }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppNav />
      </AuthProvider>
    </QueryClientProvider>
  );
}
